export const THEME_REQUEST = 'THEME_REQUEST'
export const THEME_SUCCESS = 'THEME_SUCCESS'
export const THEME_FAILURE = 'THEME_FAILURE'
export const THEME_INITIALIZED = 'THEME_INITIALIZED'
